/**
 * Размеры
 */
enum TirPmButtonSizeEnum {
  /**
   * Большая
   * */
  Big = "Big",
  /**
   * Обычный размер
   * */
  Regular = "Regular",
  /**
   * Средняя поменьше
   * */
  Middle = "Middle",
  /**
   * Маленькая
   */
  Small = "Small",
}
export default TirPmButtonSizeEnum;
